import React from 'react'

interface StateCellProps {
  state: string
}

export const StateCell = ({ state }: StateCellProps) => {
  return state === 'in_progress' ? (
    <span
      className={
        'ml-2 inline-block cursor-default rounded-md bg-[#DC2F02]/[.07] px-2 text-[10px] font-semibold uppercase leading-5 text-[#DC2F02]/[.75]'
      }
    >
      In progress
    </span>
  ) : null
}
